// extracted by mini-css-extract-plugin
module.exports = {"box":"TextStackSub--box--PFJgH","max_width":"TextStackSub--max_width--2cQIY"};